import SaveServiciosDigitales from "../../shared/saveServiciosDigitales/SaveServiciosDigitales";
import { useParams } from "react-router-dom";
import { useGetServicioDigitalById } from "@/shared/actions/erp/servicio_digital.actions";

const EditServiciosDigitales = ()=>{

  const {id} = useParams()
  const { data:dataServicioDigital, isLoading:isLoadingServicioDigital } =  useGetServicioDigitalById(id!)

  console.log({dataServicioDigital})
  if (isLoadingServicioDigital) return null 

  if (!dataServicioDigital?.data) return null

  return(
    <SaveServiciosDigitales title="Editar Solicitud de Canje" dataServicioDigital={dataServicioDigital?.data}/>
  )
}
export default EditServiciosDigitales;